(ns dnd.core
  (:require
    ;; stuff we need to require for side-effects
    [austinbirch.reactive-entity :as re]
    [day8.re-frame.http-fx]
    [day8.re-frame.async-flow-fx]
    [dnd.sentry]
    [dnd.subs.core]
    [dnd.events]

    ;; stuff we need here
    ["react" :as react]
    ["react-dom/server" :as react-dom-server]
    ["react-motion" :as ReactMotion]

    ["pubsub-js" :as PubSub]

    [dnd.util :refer [<sub
                      >evt
                      cls]]
    [goog.dom :as gdom]
    [reagent.core :as r]
    [reagent.dom]
    [re-frame.core :as rf]

    [dnd.constants :refer [session-uuid
                           app-name
                           trellis-right-sidebar-width]]
    [dnd.domain.model :as domain.model]
    [dnd.domain.session :as domain.session]
    [och-graph.core :as g]

    [dnd.ui]
    [dnd.ui.helpers :refer [<<readonly?
                            <<current-chart
                            <<pending-changesets]]
    [dnd.ui.comments :as ui.comments]
    [dnd.ui.och-toolbar]
    [dnd.ui.help]
    [dnd.lang :refer [tr]]

    [dnd.ui.sidebar.relationships]
    [dnd.ui.sidebar.contacts]
    [dnd.ui.sidebar.companies]
    [dnd.ui.sidebar.node]
    [dnd.ui.sidebar.suggestions :as ui.sidebar.suggestions]
    [dnd.ui.sidebar.docs]
    [dnd.account-map-selector]
    [dnd.display-properties]
    [dnd.account-map-deal-activity]

    [dnd.ui.dev-settings :refer [<<drag-drop-enabled?]]

    ["@material-ui/core/styles" :refer [createMuiTheme]]
    ["@material-ui/styles" :refer [ThemeProvider]]
    [material-ui.core :as m]

    ["@tippyjs/react" :default Tippy]

    [dnd.ui.orgchart]
    [datascript.core]
    [dnd.ui.subscription-upgrades]
    [dnd.first-run-flow]
    ["@sentry/react" :as Sentry]
    [dnd.domain.feature-flag :refer [can-infer-preview-charts?
                                     can-suggest-sidebar-contacts?
                                     can-use-templates?
                                     can-export-svg?
                                     can-use-hosted-browser-export?
                                     can-use-multiple-buying-groups?
                                     can-use-undo-redo?
                                     can-use-mcp-ai?]]
    [clojure.string :as str]
    ["react-helmet" :default Helmet]
    [dnd.analytics]

    [dnd.ui.inference-preview]
    [dnd.placeholder-suggestions]
    [dnd.sidebar-contacts-suggestions]
    [dnd.template.management]
    [dnd.pubsub :refer [publish-ui-canvas-zoom-to-fit!
                        publish-ui-canvas-zoom-in!
                        publish-ui-canvas-zoom-out!]]
    [dnd.domain.auth :as domain.auth]
    [dnd.ui.components.right-sidebar :as components.right-sidebar]
    [dnd.ui.components.app-load-failures :as ui.components.app-load-failures]
    [dnd.ui.components.theme
     :refer [trellis-enabled?
             themed-color]]
    [dnd.ui.motion :as ui.motion]))

(enable-console-print!)

(def Motion (.-Motion ReactMotion))

;; TODO: #EXPORT - turn all the data dependencies into subs - they are shared with the account map selector sidebar
(defn selecting-account-map-canvas
  []
  (let [graph (<sub [:sub.current-chart/graph2])
        <session (re/entity [:uuid session-uuid])
        url-company-id (:session/company-id <session)
        <portal (re/entity [:portal/id (:session/portal-id <session)])
        company-ids-on-account-maps (set (g/get-company-ids-on-chart graph))
        can-create-account-map? (not (contains? company-ids-on-account-maps url-company-id))

        account-map-ids (g/account-map-root-ids graph)
        account-maps (reduce (fn [acc account-map-id]
                               (let [company-id (g/account-map-primary-company-id graph
                                                                                  account-map-id)]
                                 (if company-id
                                   (conj acc {:account-map-id account-map-id
                                              :company (re/entity [:company/companyId company-id])})
                                   acc)))
                             []
                             account-map-ids)
        <company (re/entity [:company/companyId url-company-id])
        company-name (domain.model/company-property "name" <company)]
    [:div {:class (cls "w-full h-full")}
     (when can-create-account-map?
       [:div
        [:> Tippy
         {:content (tr "Create a new account map for %{company-name}"
                       {:company-name company-name})
          :delay 200
          :placement "left"
          :inertia true
          :hideOnClick false
          :trigger "manual"
          :duration [600 300]
          :interactive true
          :showOnCreate true
          :theme (if (trellis-enabled?) "och-trellis" "och")}
         [:div {:style {:height (if (trellis-enabled?)
                                  "300px"
                                  "274px")
                        :right (if (trellis-enabled?)
                                 (+ trellis-right-sidebar-width 10)
                                 0)
                        :position "absolute"}}]]])
     (when (seq account-maps)
       [:div
        [:> Tippy
         {:content (if can-create-account-map?
                     (tr "...or select an existing account map to open")
                     (tr "Select an existing account map to open"))
          :delay 200
          :placement "left"
          :inertia true
          :hideOnClick false
          :trigger "manual"
          :duration [600 300]
          :interactive true
          :showOnCreate true
          :theme (if (trellis-enabled?) "och-trellis" "och")}
         [:div {:style {:height (if can-create-account-map?
                                  (if trellis-enabled?
                                    "540px"
                                    "300px")
                                  (if trellis-enabled?
                                    "300px"
                                    "268px"))
                        :right (if (trellis-enabled?)
                                 (+ trellis-right-sidebar-width 10)
                                 0)
                        :position "absolute"}}]]])]))

(defn canvas-tools-overlay-container
  [{:keys [sidebar-open?]}]
  (into [:div {:class (cls "pointer-events-none"
                           "absolute inset-0")
               :style (cond-> {}
                              sidebar-open?
                              (assoc :right trellis-right-sidebar-width))}]
        (r/children (r/current-component))))

(defn- ui-sidebar-tab-bar
  [{:keys [active-tab pending-count on-change]}]
  [:div {:class "flex shrink-0 border-b border-trellis-color-border-core-subtle px-1"}
   (for [[id label badge] [[:contacts "Contacts" nil]
                           [:comments "Comments" nil]
                           [:suggestions "Suggestions" pending-count]
                           [:docs "Docs" nil]]]
     ^{:key (name id)}
     [:button {:class (cls "flex items-center gap-1.5 px-2 py-2.5"
                           "text-[13px] font-medium transition-colors"
                           (if (= active-tab id)
                             "text-gray-900 border-b-2 border-gray-900 -mb-px"
                             "text-gray-400 hover:text-gray-600"))
               :on-click #(on-change id)}
      label
      (when (and badge (pos? badge))
        [:span {:class "rounded-full bg-pink-100 text-pink-700 text-[10px] font-semibold px-1.5 py-0.5 leading-none"}
         badge])])])

(defn right-sidebar
  []
  (r/with-let [active-tab (r/atom :contacts)]
    (let [<session (re/entity [:uuid session-uuid])
          {:keys [:session.ui.flow/company-id
                  :session.ui.flow/node-id
                  :session.ui.flow/link-id
                  :session.ui.flow/mode
                  :session/portal-id]
           chart-id :session.chart.local/id} <session
          <portal (re/entity [:portal/id (:session/portal-id <session)])
          drag-and-drop-enabled? (<<drag-drop-enabled?)
          flow-node (when node-id
                      (let [<chart (<<current-chart)
                            graph (:chart/graph2 <chart)]
                        (g/get-node graph node-id)))
          heatmap-open? (<sub [:sub.session.ui.heatmap/open?])
          account-map? (-> (re/entity [:chart.local/id chart-id])
                           :chart/type
                           (= "account-map"))
          show-skeleton? (or (not (:session/loaded? <session))
                             (not (:session.chart.local/id <session)))
          pending-count (count (<<pending-changesets))
          sidebar-modal (cond
                          (and (not (trellis-enabled?))
                               show-skeleton?)
                          [dnd.ui.components.right-sidebar/sidebar-skeleton-legacy]

                          ;;(= mode :ui.flow.mode/navigating-charts)
                          ;;[chart-navigator-sidebar]

                          (= mode :ui.flow.mode/selecting-account-map)
                          [:div {:class (cls "flex flex-col relative")}
                           [dnd.account-map-selector/right-sidebar-account-map-selector]]

                          (= mode :ui.flow.mode/looking-at-contact)
                          [dnd.ui.sidebar.contacts/contact-sidebar
                           {:key "contact-sidebar"}]

                          (= mode :ui.flow.mode/looking-at-company)
                          [dnd.ui.sidebar.companies/company-sidebar
                           {:key company-id
                            :company-id company-id}]

                          (and (= mode :ui.flow.mode/looking-at-node)
                               (not (g/is-section-node? flow-node)))
                          [dnd.ui.sidebar.node/node-sidebar
                           {:key node-id
                            :node-id node-id}]

                          (= mode :ui.flow.mode/looking-at-link)
                          [dnd.ui.sidebar.relationships/link-sidebar
                           {:key link-id
                            :link-id link-id}]

                          ;; don't render a sidebar overlay on top of the
                          ;; contacts/companies list as we are not in a
                          ;; mode that requires that
                          :else nil)]
      (when-not (or (domain.session/in-uie-mode? <session)
                    (and (domain.session/in-mcp-mode? <session)
                         (not (domain.session/in-mcp-fullscreen? <session))))
        [:<>
         ;; base right sidebar, always present
         [components.right-sidebar/right-sidebar-container
          {:width trellis-right-sidebar-width
           :disabled? (or heatmap-open?
                          (and (g/is-section-node? flow-node)
                               (not= mode :ui.flow.mode2/building-command)))
           :heatmap-open? heatmap-open?}
          (when (:session/loaded? <session)
            [:div {:class (cls "flex flex-col"
                               "h-full")}
             (cond
               (and (trellis-enabled?)
                    account-map?)
               [:div {:class (cls "flex flex-col"
                                  "h-full"
                                  "space-y-2")}
                [components.right-sidebar/right-sidebar-card
                 [dnd.ui.sidebar.companies/right-sidebar-companies-panel]]
                [components.right-sidebar/right-sidebar-card
                 [dnd.ui.sidebar.companies/right-sidebar-companies-open-another-map]]]

               (and (not (trellis-enabled?))
                    account-map?)
               [:<>
                [dnd.ui.sidebar.companies/right-sidebar-companies-panel]
                [dnd.ui.sidebar.companies/right-sidebar-companies-open-another-map]]

               ;; trellis contact mapping — tabbed sidebar
               (and (not account-map?)
                    (trellis-enabled?))
               [:div {:class (cls "flex flex-col"
                                  "h-full"
                                  "space-y-2")}
                [components.right-sidebar/right-sidebar-card
                 [:div {:class "flex flex-col h-full"}
                  (when (can-use-mcp-ai? <portal)
                    [ui-sidebar-tab-bar
                     {:active-tab @active-tab
                      :pending-count pending-count
                      :on-change #(reset! active-tab %)}])
                  [:div {:class "flex flex-1 min-h-0 overflow-hidden"}
                   (case @active-tab
                     :contacts
                     (if (can-suggest-sidebar-contacts? <session <portal)
                       [dnd.sidebar-contacts-suggestions/ui-contacts-suggestions-right-sidebar]
                       [dnd.ui.sidebar.contacts/right-sidebar-contacts-panel])

                     :comments
                     [ui.comments/ui-comments-sidebar-panel]

                     :suggestions
                     [ui.sidebar.suggestions/ui-suggestions-sidebar-panel]

                     :docs
                     [dnd.ui.sidebar.docs/ui-docs-sidebar-panel])]]]

                ;; placeholder contact cell — only shown on contacts tab
                (when (and (not (<<readonly?))
                           (= @active-tab :contacts))
                  [dnd.ui.sidebar.contacts/right-sidebar-placeholder-contact-cell])]

               ;; legacy contact mapping (no tabs)
               (and (not account-map?)
                    (not (trellis-enabled?)))
               [:div {:class (cls "h-full flex flex-col"
                                  "bg-white")}
                (if (can-suggest-sidebar-contacts? <session <portal)
                  [dnd.sidebar-contacts-suggestions/ui-contacts-suggestions-right-sidebar]
                  [dnd.ui.sidebar.contacts/right-sidebar-contacts-panel])
                [dnd.ui.sidebar.contacts/right-sidebar-placeholder-contact-cell]])])]

       ;; "selected node detail" right sidebar modal, overlays on top of base
       (if (and (trellis-enabled?)
                show-skeleton?)
         [components.right-sidebar/right-sidebar-container {:width trellis-right-sidebar-width}
          [dnd.ui.components.right-sidebar/sidebar-skeleton-trellis]]
         [components.right-sidebar/right-sidebar-modal {:width trellis-right-sidebar-width}
          sidebar-modal])]))))

(defn debug-flow-state-indicator
  []
  (let [state (-> (re/entity [:uuid session-uuid])
                  :session.ui.flow/mode)]
    [:div {:style {:position "absolute"
                   :padding "0.5rem"
                   :left "0"
                   :top "0"
                   :margin "1rem"
                   :background-color "blue"
                   :color "white"}}
     state]))

(defn ui-flow-step-modal
  [{:keys [ui-mode command account-mapping?]}]
  (let [bar-height 58
        help-message-for-mode
        (fn [mode]
          (cond
            (and account-mapping?
                 (= mode :ui.flow.mode2/building-command)
                 (= (:name command) :command.name/adding-b-below))
            (tr "Please select the child company to place under this company.")

            (and account-mapping?
                 (= mode :ui.flow.mode2/building-command)
                 (= (:name command) :command.name/adding-b-above))
            (tr "Please select the parent company to place above this company.")

            (and account-mapping?
                 (= mode :ui.flow.mode2/building-command)
                 (= (:name command) :command.name/placing-a-on-chart))
            (tr "Please select a place for this company.")

            (and (= mode :ui.flow.mode2/building-command)
                 (or (= (:name command) :command.name/adding-a-above)
                     (= (:name command) :command.name/adding-b-below)))
            (tr "Please select the contact that reports into this individual.")

            (and (= mode :ui.flow.mode2/building-command)
                 (= (:name command) :command.name/swapping-a))
            (if (= (get-in command [:a :type]) :placeholder)
              (tr "Please select the contact in the sidebar you want to replace this placeholder contact with.")
              (tr "Please select the contact in the sidebar you want to replace this contact with."))

            (and (= mode :ui.flow.mode2/building-command)
                 (= (:name command) :command.name/adding-a-in-place-of))
            (if (= (get-in command [:a :type]) :placeholder)
              (tr "Please select the contact on the chart you want to replace with this placeholder.")
              (tr "Please select the contact on the chart you want to replace with this contact."))

            (and (= mode :ui.flow.mode2/building-command)
                 (or (= (:name command) :command.name/adding-a-below)
                     (= (:name command) :command.name/adding-b-above)))
            (tr "Please select the contact that manages this individual.")

            (= mode :ui.flow.mode/adding-relationship-line)
            (tr "Please select a contact that you would like to connect with a relationship line.")))]
    (let [message (help-message-for-mode ui-mode)]
      [:div {:class (cls "absolute"
                         "overflow-hidden"
                         "z-20")
             :style (if (trellis-enabled?)
                      {:top "0.6rem"
                       :left "1rem"
                       :right "1rem"}
                      {:top 0
                       :left 0
                       :right 0})}
       (if (trellis-enabled?)
         [ui.motion/animate-presence {:initial? false}
          (when message
            [ui.motion/div {:initial {:opacity 0}
                            :animate {:opacity 1}
                            :exit {:opacity 0}
                            :transition {:duration 0.2}}
             [:div {:class (cls "pointer-events-auto"
                                "flex"
                                "flex-row"
                                "px-4"
                                "items-center"

                                "h-[58px]"

                                ;; trellis
                                "bg-trellis-color-fill-info-subtle"
                                "border border-trellis-color-border-info-default"
                                "rounded-trellis-border-radius-300")}
              [:div {:class (cls "flex-auto"
                                 "text-base"
                                 "font-normal"
                                 "mr-2"

                                 ;; trellis
                                 "text-trellis-typography-body-100-font-size"
                                 "leading-trellis-typography-body-100-line-height"
                                 "tracking-trellis-typography-body-100-letter-spacing"
                                 "text-trellis-color-text-core-default")}
               message]
              [:button {:onClick (fn [e]
                                   (.preventDefault e)
                                   (.stopPropagation e)
                                   (>evt [:events.ui/reset-to-normal-mode]))
                        :style {:padding-top "0.4rem"
                                :padding-bottom "0.4rem"}
                        :class (cls "text-sm"
                                    "hover:bg-black hover:bg-opacity-5 active:bg-opacity-10"
                                    "transition-all"
                                    "rounded"
                                    "ba"
                                    "px-4"
                                    "inline-block"
                                    "text-trellis-typography-body-100-font-size"
                                    "leading-trellis-typography-body-100-line-height"
                                    "tracking-trellis-typography-body-100-letter-spacing"
                                    "text-trellis-color-text-core-default")}
               (tr "Cancel")]]])]
         [:> Motion {:style #js {:height (.spring ReactMotion (if message bar-height 0))}}
          (fn [interpolating-style]
            (r/as-element
              [:div {:style {:height (.-height interpolating-style)}
                     :class (cls "bg-ochOrange"
                                 "pointer-events-auto")}
               [:div {:class (cls "flex"
                                  "flex-row"
                                  "px-4"
                                  "h-full"
                                  "items-center")}
                [:div {:class (cls "flex-auto"
                                   "text-base"
                                   "font-normal"
                                   "mr-2"
                                   "text-white")}
                 message]
                [:button {:type "button"
                          :onClick (fn [e]
                                     (.preventDefault e)
                                     (.stopPropagation e)
                                     (>evt [:events.ui/reset-to-normal-mode]))
                          :style {:padding-top "0.4rem"
                                  :padding-bottom "0.4rem"}
                          :class (cls "text-sm"
                                      "no-underline"
                                      "rounded"
                                      "ba"
                                      "px-4"
                                      "inline-block"
                                      "text-white"
                                      "hover:bg-white hover:bg-opacity-20")}
                 (tr "Cancel")]]]))])])))

(defn head
  []
  (let [<session (re/entity [:uuid session-uuid])
        mapping-mode (:session/mapping-mode <session)
        company-id (:session/company-id <session)
        <company (when company-id
                   (re/entity [:company/companyId company-id]))
        title (domain.session/session-title {:mapping-mode mapping-mode
                                             :hs-company <company})]
    [:> Helmet
     [:title title]]))

(defn app-frame-browserless
  []
  (let [<session (re/entity [:uuid session-uuid])]
    [:<>
     (when (:session/loaded? <session)
       [:div {:id "session-loaded-for-puppeteer"
              :class "hidden"}])

     (when (:session/loaded? <session)
       [dnd.ui.orgchart/och-canvas {:key (:session.chart.local/id <session)
                                    :type "main-view"}])]))

(defn app-frame-user
  []
  (let [<session (re/entity [:uuid session-uuid])
        <portal (re/entity [:portal/id (:session/portal-id <session)])
        can-upgrade? (and (:session/loaded? <session)
                          (domain.model/can-upgrade-och-account? <portal))
        must-upgrade? (and (:session/loaded? <session)
                           (domain.model/must-upgrade-och-account? <portal))
        can-access-billing-portal? (and (domain.model/can-access-billing-portal? <portal)
                                        (domain.auth/can-access-billing? {:portal <portal
                                                                          :user-email (:session/user-email <session)}))
        {:keys [:session.ui.flow/mode
                :session/loaded?]} <session
        company-id (:session/company-id <session)
        <company (when company-id
                   (re/entity [:company/companyId company-id]))
        export-image-title (domain.session/export-image-filename
                             {:mapping-mode (:session/mapping-mode <session)
                              :hs-company <company})
        are-signups-frozen? (:session/signups-frozen <session)
        account-map? (= (:session/mapping-mode <session)
                        :session.mapping-mode/accounts-mapping)]
    [:div {:class (cls "h-full"
                       "flex"
                       "flex-col"
                       (if (trellis-enabled?)
                         "lexend-deca"
                         "inter"))
           :data-hubspot-theme (if (trellis-enabled?)
                                 "trellis-light"
                                 "och-legacy")}
     [:div {:class (cls "flex"
                        "flex-auto"
                        ;; "relative"
                        "overflow-hidden"
                        "flex-row"
                        (when-not loaded?
                          "opacity-30 pointer-events-none"))
            :data-ui-mode (str mode)}
      [:div {:class (cls "flex-auto"
                         "relative"
                         "overflow-hidden"
                         (if (trellis-enabled?)
                           "bg-trellis-color-fill-surface-recessed"
                           "bg-[#f3f7f9]"))}

       ;; TODO: maybe figure out what the bg color above + bg-black + bg-opacity-80 is and then just set that as bg color above
       (when (and (:session.ui.heatmap/open? <session)
                  (not (trellis-enabled?)))
         [:div {:class (cls "absolute inset-0"
                            "bg-black bg-opacity-80")}])

       (when must-upgrade?
         [:div {:class (cls "font-semibold absolute white z-10 flex flex-row justify-between items-center px-2 shadow-1 p-2 rounded border-2")
                :style {:top "0.6rem"
                        :left "4.5rem"
                        :right "1rem"
                        :color "#f50057"
                        :background "hsl(339deg 30% 93%)"
                        :border-color "#f50057"}}
          [:span (if are-signups-frozen?
                   (tr "You are over the free plan limit. Please message us at hello@orgcharthub.com.")
                   (tr "You are over the free plan limit. Please click the button to upgrade your account."))]
          (when (not are-signups-frozen?)
            [:> m/Button
             {:variant "contained"
              :color "secondary"
              :style {:text-transform "none"}
              :disableElevation true
              :onClick (fn []
                         (if-let [plan-id (:portal/upgrade-prompt-payment-plan-id <portal)]
                           (let [url (domain.model/make-checkout-link
                                       {:plan-id plan-id
                                        :token (:session/token <session)})]
                             (.open js/window url "_blank"))
                           (>evt [:events.och.upgrade-dialog/show])))}
             (tr "Upgrade")])])

       (when loaded?
         (if (= mode :ui.flow.mode/selecting-account-map)
           [selecting-account-map-canvas]
           (when (if (= (:session.chart.local/id <session) "account-map")
                   (seq (:session/tracking-account-map-ids <session))
                   (and (:session.chart.local/id <session)
                        (if (can-infer-preview-charts? <session <portal)
                          (let [<chart (<<current-chart)]
                            (str/blank? (:chart/active-chart-inference-uuid <chart)))
                          true)))
             [dnd.ui.orgchart/och-canvas {:key (:session.chart.local/id <session)
                                          :type "main-view"}])))

       [canvas-tools-overlay-container {:sidebar-open? (and (trellis-enabled?)
                                                            (not (domain.session/in-uie-mode? <session))
                                                            (or (not (domain.session/in-mcp-mode? <session))
                                                                (domain.session/in-mcp-fullscreen? <session)))}
        [ui-flow-step-modal {:ui-mode mode
                             :account-mapping? (= (:session/mapping-mode <session)
                                                  :session.mapping-mode/accounts-mapping)
                             :command {:a (:session.ui.command/a <session)
                                       :name (:session.ui.command/name <session)}}]

        (when (and (not= (:session/mapping-mode <session)
                         :session.mapping-mode/contacts-mapping)
                   (not= (:session.ui.flow/mode <session)
                         :ui.flow.mode/selecting-account-map)
                   (not (domain.session/in-uie-mode? <session)))
          [:div {:style {:position "absolute"
                         :left "1.2rem"
                         :right "1.2rem"
                         :top "0.8rem"
                         :z-index 2}
                 :class (cls "pointer-events-none")}
           [dnd.ui.och-toolbar/top-toolbar-account-mapping]])

        (when (and (:session/loaded? <session)
                   (not (= (:session/mapping-mode <session)
                           :session.mapping-mode/accounts-mapping))
                   (not (domain.session/in-uie-mode? <session)))
          [:div {:style {:position "absolute"
                         :left "1.2rem"
                         :right "1.2rem"
                         :top "0.8rem"
                         :z-index 2}
                 :class (cls "pointer-events-none")}
           [dnd.ui.och-toolbar/top-toolbar
            {:heatmap-open? (boolean (:session.ui.heatmap/open? <session))
             :can-upgrade? can-upgrade?
             :are-signups-frozen? are-signups-frozen?}]])

        (when (and false
                   ^boolean goog.DEBUG)
          [:div {:style {:position "absolute"
                         :bottom "1rem"
                         :right "1rem"
                         :z-index 100}
                 :class (cls "bg-red-100 px-2 pb-1 space-y-1")}
           [:span {:class (cls "text-xs font-semibold")} "onboarding state"]
           [:pre {:class (cls "text-xs")}
            (with-out-str (cljs.pprint/pprint (:session/onboarding <session)))]])

        (if (or (domain.session/in-uie-mode? <session)
                (domain.session/in-mcp-mode? <session))
          [:div {:style {:position "absolute"
                         :right "1rem"
                         :bottom "1rem"
                         :z-index 2
                         :pointer-events "auto"}}
           [dnd.ui.och-toolbar/uie-bottom-toolbar]]
          [:div {:style {:position "absolute"
                         :right (if (trellis-enabled?)
                                  "1.1rem"
                                  "1.2rem")
                         :bottom (if (trellis-enabled?)
                                   "0.6rem"
                                   "1.2rem")
                         :z-index 2}}
           [dnd.ui.och-toolbar/bottom-toolbar
            {:token (:session/token <session)
             :company-id (:session/company-id <session)
             :chart-name export-image-title
             :mapping-mode (:session/mapping-mode <session)
             :readonly? (<<readonly?)
             :sunset-banner-open? (and loaded?
                                       (= app-name "och")
                                       (boolean (:session.ui.sunset-banner/open? <session)))
             :can-delete-chart? (and (not account-map?)
                                     (domain.auth/can-delete-charts?
                                       {:portal <portal
                                        :user-email (:session/user-email <session)}))
             :can-download-chart? (boolean (domain.auth/can-download-charts?
                                             {:portal <portal
                                              :user-email (:session/user-email <session)}))
             :can-infer-preview-charts? (can-infer-preview-charts? <session
                                                                   <portal)
             :can-use-multiple-buying-groups? (or (can-use-multiple-buying-groups? <portal)
                                                   (:session/unique-chart-id-mode? <session))
             :can-create-new-buying-groups? (and (can-use-multiple-buying-groups? <portal)
                                                 (not (:session/unique-chart-id-mode? <session)))
             :can-edit-buying-groups? (domain.auth/can-edit-buying-groups?
                                        {:portal <portal
                                         :user-email (:session/user-email <session)})
             :billing-portal-enabled? can-access-billing-portal?
             :can-edit-templates? (and (can-use-templates? <portal)
                                       (domain.auth/can-edit-blueprints? {:portal <portal
                                                                          :user-email (:session/user-email <session)}))
             :can-use-undo-redo? (can-use-undo-redo? <portal)
             :fullscreen-enabled? (not (:session/outside-hubspot? <session))
             :heatmapping-open? (boolean (:session.ui.heatmap/open? <session))
             :chart-empty? (<sub [:sub.current-chart/empty?])
             :account-map-deal-activity-open? (boolean (:session.ui.account-map-deal-activity/open? <session))
             :zoom-enabled? (not (= mode :ui.flow.mode/selecting-account-map))
             :feature-och-svg-export-enabled (can-export-svg? <portal)
             :feature-can-use-hosted-browser-export (can-use-hosted-browser-export? <portal)
             :on-zoom-to-fit (fn []
                               (publish-ui-canvas-zoom-to-fit!
                                 "main"
                                 (cond-> {}
                                         (and (trellis-enabled?)
                                              (or (not (domain.session/in-mcp-mode? <session))
                                                  (domain.session/in-mcp-fullscreen? <session)))
                                         (assoc :right-spacer-size trellis-right-sidebar-width))))
             :on-zoom-in (fn []
                           (publish-ui-canvas-zoom-in! "main"))
             :on-zoom-out (fn []
                            (publish-ui-canvas-zoom-out! "main"))}]])]]

      ;; sidebar
      [right-sidebar]

      ;; inference modal
      [dnd.ui.inference-preview/ui-inference-preview-modal]

      ;; help section modal
      (when (:session.ui.help-section/is-open? <session)
        [dnd.ui.help/help-section])

      ;; control their own visibility
      [dnd.ui.subscription-upgrades/ui-upgrade-dialog]

      ;; controls own visibility
      [dnd.first-run-flow/ui-first-run-dialog]

      (when (:session.template-management/is-open? <session)
        [dnd.template.management/ui-template-management-dialog])

      (when (:session/impersonation-session <session)
        [:div {:class (cls "absolute"
                           "bg-red-500"
                           "text-white"
                           "p-2"
                           "text-sm")
               :style {:bottom "1rem"
                       :left "1rem"}}
         "impersonation session"])

      ;; debug helpers
      #_(when ^boolean goog/DEBUG
          [debug-flow-state-indicator])]]))

(defn app-frame
  []
  (let [<session (re/entity [:uuid session-uuid])]
    (if (domain.session/is-browserless-session? <session)
      [app-frame-browserless]
      [app-frame-user])))

(def mui-theme
  (createMuiTheme #js {:typography #js {:fontFamily "Inter, sans-serif"}
                       :overrides #js {:MuiTooltip
                                       #js {:tooltip #js {:fontSize "0.875rem"
                                                          :backgroundColor "rgba(27,38,49,0.9)"}
                                            :arrow #js {:color "rgba(27,38,49,0.9)"}}}}))

(defn och-app
  []
  [:> ThemeProvider {:theme mui-theme}
   [head]
   [app-frame]])

(defn app
  []
  (let [<session (re/entity [:uuid session-uuid])]
    [:> (.-ErrorBoundary Sentry)
     {:fallback (r/as-element [ui.components.app-load-failures/ui-crash])}
     (cond
       (:session.dev/show-reload-required-message? <session)
       [ui.components.app-load-failures/ui-show-dev-reload-required]

       (:session.auth/failed? <session)
       [ui.components.app-load-failures/ui-signed-out]

       (:session/initialise-failed? <session)
       [ui.components.app-load-failures/ui-crash]

       :else
       [och-app])]))

(defn mount-root
  []
  (rf/clear-subscription-cache!)
  (re/clear-cache!)
  (reagent.dom/render [#'app] (gdom/getElement "app")))

(defn on-jsload
  []
  ;; whilst we are testing bootstrap, consider on-jsload as browser reload
  ;; (rf/dispatch-sync [:reset-db])
  ;; (rf/dispatch-sync [:initialise-db])
  ;; (rf/dispatch-sync [:initialise-flow-on-reload])

  (rf/dispatch-sync [:stop-background-processes])
  (rf/dispatch-sync [:start-background-processes])
  (mount-root))

(defn ^:export seed-annotations
  "Seed random test annotations onto the current chart's nodes.
  Call from browser console: dnd.core.seed_annotations()"
  []
  (rf/dispatch [:events.annotations/dev-seed]))

(defn ^:export delete-chart
  "Emergency escape hatch — call from browser console:
   dnd.core.delete_chart()
   Dispatches the chart delete event to clear a corrupted chart."
  []
  (rf/dispatch [:events.graph/actually-delete])
  #_(rf/dispatch [:events.graph/delete]))

(defn ^:export init
  []
  (dnd.sentry/install!)
  (dnd.sentry/context
    (fn []
      (rf/dispatch-sync [:initialise-db])
      (rf/dispatch-sync [:start-background-processes])
      (mount-root))))

;; exported so that our hosted puppeteer browser can control heatmap on/off and sales/marketing mode
(defn ^:export set-heatmap-mode
  [heatmap-mode]
  (rf/dispatch-sync [:events.ui.heatmap/open-heat-map])
  (rf/dispatch-sync [:events.ui.heatmap/set-heatmap-mode
                     {:mode heatmap-mode}]))

;; TODO: #sessions-migration - remove this once all refresh tokens have expired
(defn ^:export refresh-auth
  []
  (rf/dispatch [:events.base.auth/refresh]))

(comment

  (do
    (rf/clear-subscription-cache!)
    (datascript.core/reset-conn! dnd.db/conn (datascript.core/empty-db dnd.db/schema))
    (js/setTimeout (fn []
                     (rf/dispatch-sync [:initialise-db]))
                   (* 2 1000)))

  )
